import React, { useEffect, useState } from "react";
import "./Home.css";
// import dp from '../img/dp.png';
// import dp2 from '../img/dp2.jpg';
// import dp3 from '../img/port1.jpg';
import Footer from "./Footer/Footer";
// import temp from '../img/temp.jpg';

function Home() {
  const [english, setEnglish] = useState("flex");
  const [hindi, setHindi] = useState("none");
  const [time, setTime] = useState(0);

  useEffect(() => {
    let intervalId = setInterval(() => setTime(time + 1), 10);
    let oddEve = Math.floor(Math.floor((time % 6000) / 100) / 3);
    if (oddEve % 2 === 0) {
      setEnglish("flex");
      setHindi("none");
    }
    if (oddEve % 2 !== 0) {
      setHindi("flex");
      setEnglish("none");
    }

    return () => clearInterval(intervalId);
  }, [time]);

  return (
    <div className="home" id="home">
      <div style={{ display: `${english}` }} className="home_left">
        <h2>
          <span class="animate__animated animate__tada">👋🏻</span>
          <span class="animate__animated animate__fadeIn"> Atulya Jaiswal</span>
        </h2>
        <h3 class="animate__animated animate__fadeIn">3rd Year (I.T) </h3>
        <h3 class="animate__animated animate__fadeIn">
          Guru Ghasidas Vishwavidyalaya
        </h3>
        <p class="animate__animated animate__fadeIn">
          (Full Stack Web Developer)
        </p>
        <Footer />
      </div>
      <div style={{ display: `${hindi}` }} className="home_left">
        <h2
          style={{ display: "flex" }}
          class="animate__animated animate__fadeIn">
          <span class="animate__animated animate__pulse">👏🏻</span> अतुल्य
          जायसवाल
        </h2>
        <h3 class="animate__animated animate__fadeIn">तृतीय वर्ष (आई.टी) </h3>
        <h3 class="animate__animated animate__fadeIn">
          गुरु घासीदास विश्वविद्यालय
        </h3>
        <p class="animate__animated animate__fadeIn">(फुल स्टैक वेब डेवलपर)</p>
        <Footer />
      </div>
      <div className="home_right">
        <img
          class="animate__animated animate__bounceInLeft"
          // src={dp3}
          src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMWY1NTQyMGFkYmQxNTVmNmY4ZWVjMDhiNDZmM2VhMjc1ODAwZWRkNyZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/unxCGmTuBvwo2djRLA/giphy.gif"
          alt="DP"
        />
      </div>
    </div>
  );
}

export default Home;

//GIF
// https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNmVlOGZkNDY2Y2Q5NjZiYzg4MzgwNmRiNjZjZGE5ZGFkZjc4YTk0MCZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/jOzvyDcUTPOVM6WBFW/giphy.gif
// https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNzFmMDYxNWJlYmNhMDM2YTZmYWQ4ZmQ1ZmJiODA5YTUyNjhjYzdiYSZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/cfuL5gqFDreXxkWQ4o/giphy.gif
// https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMWY1NTQyMGFkYmQxNTVmNmY4ZWVjMDhiNDZmM2VhMjc1ODAwZWRkNyZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/unxCGmTuBvwo2djRLA/giphy.gif
